import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { Block } from "@/utils/block";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import MatterDescription from "./MatterDescription.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    block: null
  },
  setup(__props: any) {

const props = __props as {
  block: Block;
}

const { t } = useI18n();

const displayName = computed(() =>
  t(props.block.design.displayName).replace(/<[^,]+,([^>]*)>/g, "$1")
);
const matterName = computed(() => {
  if (props.block.params === null) return "";
  return props.block.params[Object.keys(props.block.params)[0]].value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", null, _toDisplayString(_unref(displayName)), 1),
    _createTextVNode(" " + _toDisplayString(_unref(t)(__props.block.design.description)) + " ", 1),
    (__props.block.params !== null)
      ? (_openBlock(), _createBlock(MatterDescription, {
          key: 0,
          "matter-name": _unref(matterName)
        }, null, 8, ["matter-name"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})